export default __webpack_public_path__ + "static/media/location_inactive.ba413069.png";